import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import moment from "moment";
import { minValidDate } from "../../DataEntry/Grid/gridFunctions";
import { grayOrdisableCorresField } from "../utils";

// Helper functions (you'll need to implement these based on your existing code)
const disableCorresField1 = (field, claim,jobData, qdxTransaction) => {
  return grayOrdisableCorresField(field, claim, jobData, qdxTransaction)
};

const disableCorresField = (field,jobData, qdxTransaction) => {
  return grayOrdisableCorresField(field, null, jobData, qdxTransaction);
};

const isAutomationNpiOrTin = (npi, tin) => {
  // Your existing logic for automation NPI/TIN validation
  return false; // placeholder
};

const balanceMismatchValidation = (fieldName = null,jobData) =>
  yup
    .number()
    .nullable()
    .transform((value, originalValue) =>
      originalValue === "" ? null : value
    )
    .test(fieldName, function (value) {
      const { balance } = this.parent;
      const root = this.options?.from?.[2]?.value; 
     const { qdx_status,transaction_type,claims } = root || {};
      if (fieldName && disableCorresField1(fieldName,claims,jobData,transaction_type)) return true;
      
      if (qdx_status === "INCOMPLETE") return true;
      
      if (balance === null || balance === undefined || balance === "") {
        return this.createError({ message: "Balance is required" });
      }

      if (parseFloat(balance || 0) === 0) {
        return true;
      }

      return this.createError({ message: "Balance mismatch" });
    })

function requiredWhenIncomplete(fieldName, disableFn) {
  return yup.string().test(
    `${fieldName}_required`,
    "Required",
    function (value) {
      const root = this.options?.from?.[1]?.value; 
      const { qdx_status,transaction_type } = root || {};
      
      if (qdx_status === "INCOMPLETE") return true;
      
      if (typeof disableFn === "function" && disableFn(fieldName, this.parent,transaction_type)) {
        return true;
      }
      return !!value;
    }
  );
}


const adjustmentSchema = (num,jobData) => yup.object().shape({
  group_code: yup.string().test("group_code_validation", function (value) {
     const root = this.options?.from?.[num]?.value;
    const { qdx_status,transaction_type } = root || {};
    const { amount } = this.parent;

    const coseGrayField = !disableCorresField1(
      "group_code",
      this.options.parent?.parent,jobData,transaction_type

    );

    if (qdx_status === "INCOMPLETE" || !coseGrayField) return true;

    if (!value && parseFloat(amount || 0) !== 0) {
      return this.createError({ message: "Required" });
    }

    return true;
  }),

  reason_code: yup.string().when("group_code", (group_code, schema) =>
    schema.test("reason_code_validation", function (value) {
       const root = this.options?.from?.[num]?.value;
      const { qdx_status, isRarcCarcValidData } = root;
      const { is_invalid_reason_code } = this.parent;

      if (qdx_status === "INCOMPLETE") return true;

      // If group_code is set but reason_code is empty
      if (!!group_code && !value) {
        return this.createError({ message: "Required" });
      }

      // Max length = 3 alphanumeric
      if (value && !/^[a-zA-Z0-9]{0,3}$/.test(value)) {
        return this.createError({ message: "Maximum 3 digits" });
      }

      // Invalid reason code
      if (
        value &&
        !isRarcCarcValidData?.CARC?.includes(value?.toUpperCase()) &&
        is_invalid_reason_code
      ) {
        return this.createError({ message: "Invalid reason code" });
      }

      return true;
    })
  ),

  rmk: yup.string().test("rmk_validation", function (value) {
     const root = this.options?.from?.[num]?.value;
    const { qdx_status, isRarcCarcValidData } = root;
    const { is_invalid_rmk } = this.parent;

    if (qdx_status === "INCOMPLETE") return true;

    if (
      value &&
      (!/^[A-Za-z][A-Za-z0-9]{0,4}$/.test(value) || !/[0-9]/.test(value))
    ) {
      return this.createError({ message: "Maximum 5 characters (must start with letter and include a digit)" });
    }

    if (
      value &&
      !isRarcCarcValidData?.RARC?.includes(value?.toUpperCase()) &&
      is_invalid_rmk
    ) {
      return this.createError({ message: "Invalid RMK" });
    }

    return true;
  }),

  amount: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" ? null : value
    )
    .nullable()
    .typeError("Amount must be a number"),

//   is_invalid_reason_code: yup.boolean(),
//   is_invalid_rmk: yup.boolean(),
});
const checkDbkValidation = (value1, value2, permission) => {
  return String(value1).toUpperCase() !== String(value2).toUpperCase() && permission;
};

// Create the validation schema as a function that accepts context
export const createValidationSchema = (contextValues = {}) => {
  // const { jobData,isRarcCarcValidData = { CARC: [], RARC: [] ,transactionType} } = contextValues;
   const {
    totalPages,
    jobData,
    isSubJob,
    isFirstJob,
    isPayerPage,
    isPayeePage,
    isAdditional,
    isAdditionalInfoOptions,
    qdxTransaction,
    isRarcCarcValidData= { CARC: [], RARC: [] ,transactionType},
    isDbkPermission,
    transactionType ,

  } = contextValues;

 
  return yup.object().shape({
    overall_page_from: yup.string().when("qdx_status", {
    is: (val) => val !== "INCOMPLETE",
    then: (schema) =>
        jobData?.client_level_customization?.overall_page_from
        ? schema
            .required("Invalid Page Number")
            .test("overall_page_from_validation", "Invalid Page Number", function (value) {
                const { overall_page_to } = this.parent;
                const { totalPages } = this.options.context || {};

                // Check if value is empty, zero, or invalid
                if (!value || value <= 0) {
                return false;
                }

                // Check if exceeds total pages
                if (value > totalPages) {
                return false;
                }

                // Check if from is greater than to
                if (overall_page_to && parseInt(value) > parseInt(overall_page_to)) {
                return false;
                }

                return true;
            })
        : schema, // not required if flag is false
    }),

    overall_page_to: yup.string().when("qdx_status", {
    is: (val) => val !== "INCOMPLETE",
    then: (schema) =>
        jobData?.client_level_customization?.overall_page_to
        ? schema
            .required("Invalid Page Number")
            .test("overall_page_to_validation", "Invalid Page Number", function (value) {
                const { overall_page_from } = this.parent;
                const { totalPages } = this.options.context || {};

                // Check if value is empty, zero, or invalid
                if (!value || value <= 0) {
                return false;
                }

                // Check if exceeds total pages
                if (value > totalPages) {
                return false;
                }

                // Check if from is greater than to
                if (overall_page_from && parseInt(overall_page_from) > parseInt(value)) {
                return false;
                }

                return true;
            })
        : schema, // not required if flag is false
    }),


    // Status and reason validation
    qdx_status: yup.string().when("$isAdditional", {
      is: true,
      then: (schema) => schema.when("$isAdditionalInfoOptions.status", {
        is: true,
        then: (schema) => schema.required("Required")
      })
    }),
    
    qdx_reason: yup
      .array()
      .of(yup.number().typeError("Must be a number"))
      .when(["qdx_status", "$isAdditional"], {
        is: (status, isAdditional) => isAdditional && status === "INCOMPLETE",
        then: (schema) =>
          schema.when("$isAdditionalInfoOptions.reason", {
            is: true,
            then: (schema) =>
              schema.min(1, "At least one reason is required"), // must contain numbers
            otherwise: (schema) => schema, // allow empty array
          }),
        otherwise: (schema) => schema, // allow empty array
      }),

    payment_method: yup.string().when("qdx_status", {
      is: (val) => val !== "INCOMPLETE",
      then: (schema) => schema.when(["$isSubJob", "$isFirstJob"], {
        is: (isSubJob, isFirstJob) => (isSubJob && isFirstJob) || (!isSubJob && !isFirstJob),
        then: (schema) => schema.test("payment_method_validation", function(value) {
          const { check_amount, transaction_type } = this.parent;
          
          if (!value) return this.createError({ message: "Select an option" });

          if (check_amount === null || check_amount === undefined || check_amount === "" ||isNaN(check_amount)) {
            return this.createError({ message: "Check amount is required" });
          }
          const checkAmountFloat = parseFloat(check_amount ).toFixed(2);
          const zeroAmount = parseFloat(0).toFixed(2);
          
          // Check Amount and Payment Method validation
          if (checkAmountFloat === zeroAmount && value !== "NON" && value !== "COR") {
            return this.createError({ message: "Invalid Selection only NON or COR" });
          }
          
          if (checkAmountFloat > zeroAmount && !["CHK", "ACH", "VCP", "OTH", "CCI"].includes(value)) {
            return this.createError({ message: "Invalid Selection select Otherthan NON or COR" });
          }
          
          // Payment Method and Transaction Type validation
          if (value === "COR" && transaction_type !== "CORRESPONDENCE_835") {
            return this.createError({ message: "Wrong Transaction Type" });
          }
          
          if (value !== "COR" && transaction_type === "CORRESPONDENCE_835") {
            return this.createError({ message: "Wrong Transaction Type" });
          }
          
          return true;
        })
      })
    }),


    check_amount: yup
      .string()
    //   .typeError("Check amount is required") // if not a valid number
    //   .required("Check amount is required") // disallow null/undefined
      .when("payment_method", (payment_method, schema) =>
        schema.test("check_amount_validation", function (value) {
          const { qdx_status } = this.parent;

          if (qdx_status === "INCOMPLETE") return true;

          const checkAmount = parseFloat(value || 0).toFixed(2);
          const zeroAmount = parseFloat(0).toFixed(2);

          // Negative check amount
          if (parseFloat(checkAmount) < parseFloat(zeroAmount)) {
            return this.createError({ message: "Negative value" });
          }

          // Rule 1: Zero check amount but invalid payment method
          if (
            checkAmount === zeroAmount &&
            payment_method !== "NON" &&
            payment_method !== "COR"
          ) {
            return this.createError({
              path: "check_amount",
              message: "Invalid Selection -NON or COR",
            });
          }

          // Rule 2: Empty check amount with NON
          if (!value && payment_method !== "NON") {
            return this.createError({
              path: "check_amount",
              message: "Invalid Selection mustbe NON",
            });
          }

          // Rule 3: Positive check amount but wrong payment method
          if (
            parseFloat(checkAmount) > parseFloat(zeroAmount) &&
            !["CHK", "ACH", "VCP", "OTH", "CCI"].includes(payment_method)
          ) {
            return this.createError({
              path: "check_amount",
              message: "Invalid Selection",
            });
          }

          return true;
        })
      ),

    // Main validation when status is not INCOMPLETE
    payer_name: yup.string().when("qdx_status", {
      is: (val) => val !== "INCOMPLETE",
      then: (schema) => schema.when(["$isSubJob", "$isFirstJob"], {
        is: (isSubJob, isFirstJob) => (isSubJob && isFirstJob) || (!isSubJob && !isFirstJob),
        then: (schema) => schema.required("Required")
      })
    }),

    payer_address: yup.string().when("qdx_status", {
      is: (val) => val !== "INCOMPLETE",
      then: (schema) => schema.when(["$isSubJob", "$isFirstJob"], {
        is: (isSubJob, isFirstJob) => (isSubJob && isFirstJob) || (!isSubJob && !isFirstJob),
        then: (schema) => schema.test("payer_address_required", "Required", function(value) {
            const {transaction_type} = this.parent
          if (disableCorresField('payer_address',jobData,transaction_type)) return true;
          return !!value;
        })
      })
    }),

    payer_city: yup.string().when("qdx_status", {
      is: (val) => val !== "INCOMPLETE",
      then: (schema) => schema.when(["$isSubJob", "$isFirstJob"], {
        is: (isSubJob, isFirstJob) => (isSubJob && isFirstJob) || (!isSubJob && !isFirstJob),
        then: (schema) => schema.test("payer_city_required", "Required", function(value) {
          const {transaction_type} = this.parent
          if (disableCorresField('payer_city',jobData,transaction_type)) return true;
          return !!value;
        })
      })
    }),

    payer_state: yup.string().when("qdx_status", {
      is: (val) => val !== "INCOMPLETE",
      then: (schema) => schema.when(["$isSubJob", "$isFirstJob"], {
        is: (isSubJob, isFirstJob) => (isSubJob && isFirstJob) || (!isSubJob && !isFirstJob),
        then: (schema) => schema.test("payer_state_validation", function(value) {
          const {transaction_type} = this.parent
          if (disableCorresField('payer_state',jobData,transaction_type)) return true;
          if (!value) return this.createError({ message: "Required" });
          
          const { $isFirstJob } = this.options.context || {};
          if (!$isFirstJob && value && !/^[a-zA-Z]{2}$/.test(value)) {
            return this.createError({ message: "Enter a valid State Abbreviation" });
          }
          return true;
        })
      })
    }),

    payer_zip: yup.string().when("qdx_status", {
      is: (val) => val !== "INCOMPLETE",
      then: (schema) => schema.when(["$isSubJob", "$isFirstJob"], {
        is: (isSubJob, isFirstJob) => (isSubJob && isFirstJob) || (!isSubJob && !isFirstJob),
        then: (schema) => schema.test("payer_zip_validation", function(value) {
          const {transaction_type} = this.parent
          if (disableCorresField('payer_zip',jobData,transaction_type)) return true;
          if (!value) return this.createError({ message: "Required" });
          if (value && !/(^\d{5}$)|(^\d{5}-\d{4}$)|(^\d{5}\d{4}$)/.test(value)) {
            return this.createError({ message: "Enter a valid Zip code" });
          }
          return true;
        })
      })
    }),

    payee_npi: yup.string().when("qdx_status", {
      is: (val) => val !== "INCOMPLETE",
      then: (schema) => schema.test("payee_npi_validation", function(value) {
        const { tax_identification_number, is_valid_payee_npi, data_837, is_valid_tax_identification_number } = this.parent;
        
        if (!value) return true;
        
        if (!/^[0-9]{10}$/.test(value)) {
          return this.createError({ message: "Must be 10 digits" });
        }

        if (value && is_valid_payee_npi && 
             data_837?.[data_837?.length - 1]?.payee_npi?.toUpperCase() !== value.toUpperCase() &&
            // isAutomationNpiOrTin(value, tax_identification_number) &&
            (jobData?.default_payee?.default_npi !== value && (is_valid_payee_npi || is_valid_tax_identification_number))) {
          return this.createError({ message: "NPI Missmatched" });
        }

        return true;
      })
    }),

    tax_identification_number: yup.string().when("qdx_status", {
      is: (val) => val !== "INCOMPLETE",
      then: (schema) => schema.test("tax_id_validation", function(value) {
        const { payee_npi, is_valid_tax_identification_number, data_837, is_valid_payee_npi } = this.parent;
        
        if (!value) return true;
        
        if (!/^[0-9]{9}$/.test(value)) {
          return this.createError({ message: "Must be 9 digits" });
        }

        if (value && is_valid_tax_identification_number && 
             data_837?.[data_837?.length - 1]?.tax_identification_number?.toUpperCase() !== value.toUpperCase() &&
            // isAutomationNpiOrTin(payee_npi, value) &&
            (jobData?.default_payee?.default_tin !== value && (is_valid_payee_npi || is_valid_tax_identification_number))) {
          return this.createError({ message: "Tax ID Missmatched" });
        }

        return true;
      })
    }),

    payee_zip: yup.string().test("payee_zip_validation", "Enter a valid Zip code", function(value) {
      if (!value) return true;
      return /(^\d{5}$)|(^\d{5}-\d{4}$)|(^\d{5}\d{4}$)/.test(value);
    }),

    payee_state: yup.string().when("$isFirstJob", {
      is: false,
      then: (schema) => schema.test("payee_state_validation", "Enter a valid State Abbreviation", function(value) {
        if (!value) return true;
        return /^[a-zA-Z]{2}$/.test(value);
      })
    }),

    credit_card_payment_method: yup.string().when(["payment_method", "transaction_type"], {
      is: (paymentMethod, transactionType) => paymentMethod === "VCP" && transactionType === "PATIENT_PAY",
      then: (schema) => schema.when("$jobData.client_level_customization.is_enabled_nextgen_patient_pay", {
        is: true,
        then: (schema) => schema.required("Required")
      })
    }),

    payment_source: yup.string().when("transaction_type", {
      is: "PATIENT_PAY",
      then: (schema) => schema.when("$jobData.client_level_customization.is_enable_payment_source", {
        is: true,
        then: (schema) => schema.required("Required")
      })
    }),

  

    check_number: yup.string().when("qdx_status", {
      is: (val) => val !== "INCOMPLETE",
      then: (schema) => schema.when(["$isSubJob", "$isFirstJob"], {
        is: (isSubJob, isFirstJob) => (isSubJob && isFirstJob) || (!isSubJob && !isFirstJob),
        then: (schema) => schema.required("Required")
      })
    }),




    aba_routing_number: yup.string().test("aba_routing_validation", function(value) {
      const { payment_method,qdx_status } = this.parent;

      if (!jobData?.client_level_customization?.is_aba_routing_number || qdx_status === "INCOMPLETE") return true;
      
      if (!value && (payment_method === "CHK" || payment_method === "OTH" || !payment_method)) {
        return this.createError({ message: "Invalid Selection" });
      }
      
      if (value && !(payment_method === "CHK" || payment_method === "OTH")) {
        return this.createError({ message: "Invalid Selection" });
      }
      
      return true;
    }),

    payer_account_number: yup.string().test("payer_account_validation", function(value) {
      const { payment_method,qdx_status } = this.parent;
      
      if (!jobData?.client_level_customization?.is_payer_account_number || qdx_status === "INCOMPLETE") return true;
      
      if (!value && (payment_method === "CHK" || payment_method === "OTH" || !payment_method)) {
        return this.createError({ message: "Invalid Selection" });
      }
      
      if (value && !(payment_method === "CHK" || payment_method === "OTH")) {
        return this.createError({ message: "Invalid Selection" });
      }
      
      return true;
    }),

    remaining_balance: yup.string().when(["$isSubJob", "qdx_status"], {
    is: (isSubJob, qdx_status) => !isSubJob && qdx_status !== "INCOMPLETE",
    then: (schema) => schema.test("remaining_balance_zero", "Remaining balance must be zero", function(value) {
        return parseFloat(value || 0).toFixed(2) === parseFloat(0).toFixed(2);
    })
    }),

    check_page_number: yup
      .string()
      .transform((value, originalValue) => {
        return originalValue === "" ? undefined : value;
      })
      .nullable()
      .when(["payment_method", "qdx_status"], {
        is: (paymentMethod, qdxStatus) =>
          qdxStatus !== "INCOMPLETE" &&
          (paymentMethod === "CHK" || paymentMethod === "VCP"),
        then: (schema) =>
          schema.test(
            "check_page_validation",
            "Required",
            function (value) {
              const root = this.options?.from?.[1]?.value; 
              const { transaction_type } = root || {};

              const { totalPages } = this.options.context || {};
              const isEmpty = value === undefined || value === null;

              // Skip if field disabled
              if (disableCorresField("check_page_number",jobData, transaction_type)) return true;

              // Required check
              if (isEmpty) return false;

              // Bounds check
              if ((totalPages && value > totalPages) || value <= 0) {
                return false;
              }

              return true;
            }
          ),
        otherwise: (schema) => schema.nullable(),
      }),

    check_date: yup.string().test("check_date_validation", function(value) {
      const { qdx_status } = this.parent;
      
      const cleanDate = value?.replace("__/__/____", "");
      
      if (qdx_status !== "INCOMPLETE" && !cleanDate) {
        return this.createError({ message: "Required" });
      }
      
      if (cleanDate && (!moment(cleanDate, "MM/DD/YYYY", true).isValid() || !moment(cleanDate, "MM/DD/YYYY", true).isAfter(minValidDate))) {
        return this.createError({ message: "Invalid date" });
      }
      
      return true;
    }),

    // Payer and Payee page validations
    payer_page_from: yup.string().when(["$isPayerPage", "qdx_status"], {
    is: (isPayerPage, qdx_status) => isPayerPage && qdx_status !== "INCOMPLETE",
    then: (schema) =>
        schema.test(
        "payer_page_from_validation",
        "Invalid Page Number",
        function (value) {
            const { payer_page_to } = this.parent;
            const { totalPages } = this.options.context || {};

            if (value <= 0 || !value || value > totalPages || value > payer_page_to) {
            return false;
            }
            return true;
        }
        ),
    }),

    payer_page_to: yup.string().when(["$isPayerPage", "qdx_status"], {
    is: (isPayerPage, qdx_status) => isPayerPage && qdx_status !== "INCOMPLETE",
    then: (schema) =>
        schema.test(
        "payer_page_to_validation",
        "Invalid Page Number",
        function (value) {
            const { payer_page_from } = this.parent;
            const { totalPages } = this.options.context || {};

            if (value <= 0 || !value || value > totalPages || payer_page_from > value) {
            return false;
            }
            return true;
        }
        ),
    }),

    payee_page_from: yup.string().when(["$isPayeePage", "qdx_status"], {
    is: (isPayeePage, qdx_status) => isPayeePage && qdx_status !== "INCOMPLETE",
    then: (schema) =>
        schema.test(
        "payee_page_from_validation",
        "Invalid Page Number",
        function (value) {
            const { payee_page_to } = this.parent;
            const { totalPages } = this.options.context || {};

            if (value <= 0 || !value || value > totalPages || value > payee_page_to) {
            return false;
            }
            return true;
        }
        ),
    }),

    payee_page_to: yup.string().when(["$isPayeePage", "qdx_status"], {
    is: (isPayeePage, qdx_status) => isPayeePage && qdx_status !== "INCOMPLETE",
    then: (schema) =>
        schema.test(
        "payee_page_to_validation",
        "Invalid Page Number",
        function (value) {
            const { payee_page_from } = this.parent;
            const { totalPages } = this.options.context || {};

            if (value <= 0 || !value || value > totalPages || payee_page_from > value) {
            return false;
            }
            return true;
        }
        ),
    }),


    // PLB Adjustments validation
    plb_adjustments: yup.array().when("qdx_status", {
    is: (val) => val !== "INCOMPLETE",
    then: (schema) => schema.of(
        yup.object().shape({
        reason: yup.string().required("select a valid option"),
        
        plb_amt: yup.string()
            .required("Select a valid option")
            .test("not_empty_or_zero", "Select a valid option", function(value) {
            if (!value || value === "" || value === null || parseFloat(value).toFixed(2) === parseFloat(0).toFixed(2)) {
                return false;
            }
            return true;
            })
            .test("valid_amount", "Must be a valid amount", function(value) {
            if (value && !/^[+-]?[0-9]{1,9}(?:\.[0-9]{1,2})?$/.test(value)) {
                return false;
            }
            return true;
            }),

        npi: yup.string()
            .required("required")
            .test("npi_format", "Must be only digits", function(value) {
            if (value && value !== "" && !/^[0-9]{10}$/.test(value)) {
                return false;
            }
            return true;
            })
        })
    ),
    otherwise: (schema) => schema.optional()
    }),

    // Claims validation
    claims: yup.array().when("grid_customization", {
      is: (val) => val !== 'PLB_ONLY',
      then: (schema) => schema.of(
        yup.object().shape({

          patient_account_number: requiredWhenIncomplete("patient_account_number"),
          payer_claim_number: requiredWhenIncomplete("payer_claim_number", disableCorresField),

          status_code: yup.string().test("status-required", "Select an option", function (value) {
            const root = this.options?.from?.[1]?.value;
            const { qdx_status } = root || {};

            if (qdx_status !== "INCOMPLETE" && !value) {
              return this.createError({ message: "Select an option" });
            }
            return true;
          }),

          period_start: yup.string().test("period_start_validation", function(value) {
            const root = this.options?.from?.[1]?.value;
            const { qdx_status } = root || {};
            
            const cleanDate = value?.replace("__/__/____", "");
            
            if (qdx_status !== "INCOMPLETE" && !cleanDate) {
              return this.createError({ message: "Required" });
            }
            
            if (cleanDate && (!moment(cleanDate, "MM/DD/YYYY", true).isValid() || !moment(cleanDate, "MM/DD/YYYY", true).isAfter(minValidDate))) {
              return this.createError({ message: "Invalid date" });
            }
            
            return true;
          }),

          period_end: yup.string().test("period_end_validation", function(value) {
            const root = this.options?.from?.[1]?.value;
            const { qdx_status } = root || {};
            const { period_start } = this.parent;
            
            const cleanDate = value?.replace("__/__/____", "");
            
            if (qdx_status !== "INCOMPLETE" && !cleanDate) {
              return this.createError({ message: "Required" });
            }
            
            const isValidDate = cleanDate && (!moment(cleanDate, "MM/DD/YYYY", true).isValid() || !moment(cleanDate, "MM/DD/YYYY", true).isAfter(minValidDate));
            
            if (isValidDate) {
              return this.createError({ message: "Invalid date" });
            }
            
            if (!isValidDate && cleanDate && !moment(cleanDate, "MM/DD/YYYY").isSameOrAfter(period_start)) {
              return this.createError({ message: "Exceed the period_end date" });
            }
            
            return true;
          }),

          claim_balance: yup.string().test("claim_balance_zero", "Calculation Mistake", function(value) {
            const root = this.options?.from?.[1]?.value;
            const { qdx_status } = root || {};
            
            if (qdx_status === "INCOMPLETE") return true;
            
            return parseFloat(value || 0).toFixed(2) === parseFloat(0).toFixed(2);
          }),

          claim_billed: yup.string().test("claim_balance_zero", "Calculation Mistake", function(value) {
            const root = this.options?.from?.[1]?.value;
            const claim_balance = this.options?.parent?.claim_balance;
            const { qdx_status } = root || {};

            if (qdx_status === "INCOMPLETE") return true;
            
            return parseFloat(claim_balance || 0).toFixed(2) === parseFloat(0).toFixed(2);
          }),

            claim_allowed: yup.string().test("claim_allowed_mismatch", "Amount Mismatch", function(value) {
                const root = this.options?.from?.[1]?.value;
                const { qdx_status } = root || {};
                const { sl_allowed } = this.parent;
                
                if (qdx_status === "INCOMPLETE") return true;
                
                const claimAllowed = parseFloat(value || 0).toFixed(2);
                const serviceLineAllowed = parseFloat(sl_allowed || 0).toFixed(2);
                
                if (serviceLineAllowed !== "0.00" && value !== "" && claimAllowed !== serviceLineAllowed) {
                return this.createError({ message: "Amount Mismatch" });
                }
                
                return true;
            }),

            claim_deduct: yup.string().test("claim_deduct_mismatch", "Amount Mismatch", function(value) {
                const root = this.options?.from?.[1]?.value;
                const { qdx_status } = root || {};
                const { sl_deduct } = this.parent;
                
                if (qdx_status === "INCOMPLETE") return true;
                
                const claimDeduct = parseFloat(value || 0).toFixed(2);
                const serviceLineDeduct = parseFloat(sl_deduct || 0).toFixed(2);
                
                if (serviceLineDeduct !== "0.00" && value !== "" && claimDeduct !== serviceLineDeduct) {
                return this.createError({ message: "Amount Mismatch" });
                }
                
                return true;
            }),

            claim_coins: yup.string().test("claim_coins_mismatch", "Amount Mismatch", function(value) {
                const root = this.options?.from?.[1]?.value;
                const { qdx_status } = root || {};
                const { sl_coins } = this.parent;
                
                if (qdx_status === "INCOMPLETE") return true;
                
                const claimCoins = parseFloat(value || 0).toFixed(2);
                const serviceLineCoins = parseFloat(sl_coins || 0).toFixed(2);
                
                if (serviceLineCoins !== "0.00" && value !== "" && claimCoins !== serviceLineCoins) {
                return this.createError({ message: "Amount Mismatch" });
                }
                
                return true;
            }),

            claim_copay: yup.string().test("claim_copay_mismatch", "Amount Mismatch", function(value) {
                const root = this.options?.from?.[1]?.value;
                const { qdx_status } = root || {};
                const { sl_copay } = this.parent;
                
                if (qdx_status === "INCOMPLETE") return true;
                
                const claimCopay = parseFloat(value || 0).toFixed(2);
                const serviceLineCopay = parseFloat(sl_copay || 0).toFixed(2);
                
                if (serviceLineCopay !== "0.00" && value !== "" && claimCopay !== serviceLineCopay) {
                return this.createError({ message: "Amount Mismatch" });
                }
                
                return true;
            }),

            claim_cob: yup.string().test("claim_cob_mismatch", "Amount Mismatch", function(value) {
                const root = this.options?.from?.[1]?.value;
                const { qdx_status } = root || {};
                const { sl_cob } = this.parent;
                
                if (qdx_status === "INCOMPLETE") return true;
                
                const claimCob = parseFloat(value || 0).toFixed(2);
                const serviceLineCob = parseFloat(sl_cob || 0).toFixed(2);
                
                if (serviceLineCob !== "0.00" && value !== "" && claimCob !== serviceLineCob) {
                return this.createError({ message: "Amount Mismatch" });
                }
                
                return true;
            }),

            claim_paid: yup.string().test("claim_paid_mismatch", "Amount Mismatch", function(value) {
                const root = this.options?.from?.[1]?.value;
                const { qdx_status } = root || {};
                const { sl_paid } = this.parent;
                
                if (qdx_status === "INCOMPLETE") return true;
                
                const claimPaid = parseFloat(value || 0).toFixed(2);
                const serviceLinePaid = parseFloat(sl_paid || 0).toFixed(2);
                
                if (serviceLinePaid !== "0.00" && value !== "" && claimPaid !== serviceLinePaid) {
                return this.createError({ message: "Amount Mismatch" });
                }
                
                return true;
            }),
            
          rendering_provider_identifier_code: yup.string().test("rendering_provider_validation", function(value) {
            
            const root = this.options?.from?.[1]?.value;
            const { qdx_status,transaction_type } = root || {};
            const { rendering_provider } = this.parent;
            
            if (qdx_status === "INCOMPLETE") return true;
            if (!rendering_provider) return true;
            if (disableCorresField1('rendering_provider_identifier_code', this.parent,jobData,transaction_type)) return true;
            
            if (!value) {
              return this.createError({ message: "required" });
            }
            
            if (!/^[0-9]{9,10}$/.test(value)) {
              return this.createError({ message: "Must be only digits" });
            }
            
            return true;
          }),
         
          page_from: yup.string().test(
            "page_from_mismatch",
            "Invalid Page Number",
            function (value1) {
              const root = this.options?.from?.[1]?.value;
              const { qdx_status } = root || {};
              const { page_to } = this.parent;
              const { totalPages } = this.options.context || {};
              const value = Number(value1);

              if (qdx_status === "INCOMPLETE") return true;

              if (!value || value <= 0 || value > totalPages) return false;

              if (page_to && value > Number(page_to)) return false;

              // ✅ large batch job checks
              if (jobData?.is_large_batch_job) {
                const isHeaderRange =jobData?.header_range?.some(i => Number(i) === value) 
                const isFooterRange =  jobData?.footer_range?.some(i => Number(i) === value);

                if (jobData?.is_last_sub_job && isHeaderRange) return false;

                if (
                  !jobData?.is_last_sub_job &&
                  !jobData?.is_first_sub_job &&
                  isFooterRange
                )return false;
              }

              return true;
            }
          ),

          page_to: yup.string().test(
            "page_to_validation",
            "Invalid Page Number",
            function (value1) {
              const root = this.options?.from?.[1]?.value; // ✅ FIX: also consistent
              const { qdx_status } = root || {};
              const { page_from } = this.parent;
              const { totalPages } = this.options.context || {};
              const value = Number(value1);

              if (qdx_status === "INCOMPLETE") return true;

              if (!value || value <= 0 || value > totalPages) return false;

              if (page_from && Number(page_from) > value) return false;

                // ✅ large batch job checks
              if (jobData?.is_large_batch_job) {
                const isHeaderRange =jobData?.header_range?.some(i => Number(i) === value) 
                const isFooterRange =  jobData?.footer_range?.some(i => Number(i) === value);

                if (jobData?.is_last_sub_job && isHeaderRange) return false;

                if (
                  !jobData?.is_last_sub_job &&
                  !jobData?.is_first_sub_job &&
                  isFooterRange
                )return false;
              }

              return true;
            }
          ),
        

          // Service lines validation
          service_lines: yup.array().of(
            yup.object().shape({
              procedure_type: yup.string().when("$qdx_status", {
                is: (val) => val !== "INCOMPLETE",
                then: (schema) => schema.required("Invalid option")
              }),

              code: yup.string().test("code_validation", function(value) {
                const root = this.options?.from?.[2]?.value;
                const { qdx_status,transaction_type } = root || {};
                
                const coseGrayField = !disableCorresField1('code', this.options.parent,jobData,transaction_type);
                
                if (qdx_status === "INCOMPLETE" || !coseGrayField) return true;
                
                if (!value) {
                  return this.createError({ message: "Required" });
                }
                
                if (!/^[A-Za-z0-9]{5}$/.test(value)) {
                  return this.createError({ message: "Enter a Valid Code" });
                }
                
                return true;
              }),

              from_date: yup.string().test("from_date_validation", function(value) {
                const cleanDate = value?.replace("__/__/____", "");
                if (cleanDate && (!moment(cleanDate, "MM/DD/YYYY", true).isValid() || !moment(cleanDate, "MM/DD/YYYY", true).isAfter(minValidDate))) {
                  return this.createError({ message: "Invalid date" });
                }
                
                const root = this.options?.from?.[2]?.value;
                const { qdx_status } = root || {};
                if(qdx_status==='INCOMPLETE')return true
                
                
                if (!cleanDate) {
                  return this.createError({ message: "Required" });
                }
                
                
                return true;
              }),

              to_date: yup.string().test("to_date_validation", function(value) {
                const { from_date } = this.parent;
                const cleanDate = value?.replace("__/__/____", "");
                
               
                const isValidDate = cleanDate && (!moment(cleanDate, "MM/DD/YYYY", true).isValid() || !moment(cleanDate, "MM/DD/YYYY", true).isAfter(minValidDate));
                
                if (isValidDate) {
                  return this.createError({ message: "Invalid date" });
                }

                const root = this.options?.from?.[2]?.value;
                const { qdx_status } = root || {};
                if(qdx_status==='INCOMPLETE')return true

                 if (!cleanDate) {
                  return this.createError({ message: "Required" });
                }

                if (!isValidDate && !moment(cleanDate, "MM/DD/YYYY").isSameOrAfter(from_date)) {
                  return this.createError({ message: "Exceed the from date" });
                }
                
                return true;
              }),

            modifier1: yup.string().test("modifier1_validation", "Enter a Valid modifier1", function(value) {
                const { qdx_status } = this.options?.from?.[2]?.value;;
                
                if (qdx_status === "INCOMPLETE") return true;
                if (!value) return true;
                return /^[A-Za-z0-9]{2,2}$/.test(value);
                }),

                modifier2: yup.string().test("modifier2_validation", "Enter a Valid modifier2", function(value) {
                const { qdx_status } = this.options?.from?.[2]?.value;;
                
                if (qdx_status === "INCOMPLETE") return true;
                if (!value) return true;
                return /^[A-Za-z0-9]{2,2}$/.test(value);
            }),

            modifier3: yup.string().test("modifier3_validation", "Enter a Valid modifier3", function(value) {
                const { qdx_status } = this.options?.from?.[2]?.value;;
                
                if (qdx_status === "INCOMPLETE") return true;
                if (!value) return true;
                return /^[A-Za-z0-9]{2,2}$/.test(value);
                }),

                modifier4: yup.string().test("modifier4_validation", "Enter a Valid modifier4", function(value) {
                const { qdx_status } = this.options?.from?.[2]?.value;;
                
                if (qdx_status === "INCOMPLETE") return true;
                if (!value) return true;
                return /^[A-Za-z0-9]{2,2}$/.test(value);
            }),

            rev_code: yup.string().test("rev_code_validation", "Enter a Valid rev_code", function(value) {
                const { qdx_status } = this.options?.from?.[2]?.value;;
                
                if (qdx_status === "INCOMPLETE") return true;
                if (!value) return true;
                return /^[ A-Za-z0-9_@./#&+-]{3,4}$/.test(value);
            }),

              // Financial field validations with balance mismatch check
              billed: balanceMismatchValidation(),

              discount: balanceMismatchValidation('discount',jobData),

              allowed: balanceMismatchValidation('allowed',jobData),

              deduct: balanceMismatchValidation('deduct',jobData),

              coins: balanceMismatchValidation('coins',jobData),

              copay: balanceMismatchValidation('copay',jobData),

              cob: balanceMismatchValidation('cob',jobData),

              paid: balanceMismatchValidation('paid',jobData),

                // Adjustments validation
                // adjustments: yup.array().of(
                // yup.object().shape({
                //     group_code: yup.string().test("group_code_validation", function(value) {
                //     const root = this.options?.from?.[3]?.value;
                //     const { qdx_status } = root || {};
                //     const { amount } = this.parent;
                //     const coseGrayField = !disableCorresField1('group_code', this.options.parent?.parent);
                    
                //     if (qdx_status === "INCOMPLETE" || !coseGrayField) return true;
                    
                //     if (value === '' && parseFloat(amount || 0) !== 0) {
                //         return this.createError({ message: "Required" });
                //     }
                    
                //     return true;
                //     }),

                //   reason_code: yup.string().when("group_code", (group_code, schema) =>
                //     schema.test("reason_code_validation", function (value) {
                //      const root = this.options?.from?.[3]?.value;
                //     const { qdx_status } = root || {};
                //       const { is_invalid_reason_code } = this.parent;

                //       if (qdx_status === "INCOMPLETE") return true;

                //       // If group_code is set but reason_code is empty
                //       if (group_code !== "" && !value) {
                //         return this.createError({ message: "Required" });
                //       }

                //       // Max length = 3 alphanumeric
                //       if (value && !/^[a-zA-Z0-9]{0,3}$/.test(value)) {
                //         return this.createError({ message: "Maximum 3 digits" });
                //       }

                //       // Invalid reason code
                //       if (
                //         value &&
                //         !root.isRarcCarcValidData?.CARC?.includes(value?.toUpperCase()) &&
                //         is_invalid_reason_code
                //       ) {
                //         return this.createError({ message: "Invalid reason code" });
                //       }

                //       return true;
                //     })
                //   ),

                //   rmk: yup.string().test("rmk_validation", function (value) {
                //     const root = this.options?.from?.[3]?.value;
                //     const { qdx_status } = root || {};

                  
                //     const { is_invalid_rmk } = this.parent;
                    
                //     if (qdx_status === "INCOMPLETE") return true;
                    
                //     if (value !== '' && (!/^[A-Za-z][A-Za-z0-9]{0,4}$/.test(value) || !/[0-9]/.test(value))) {
                //         return this.createError({ message: "Maximum 5 digits" });
                //     }
                    
                //     if (value && !isRarcCarcValidData.RARC?.includes(value?.toUpperCase()) && is_invalid_rmk) {
                //         return this.createError({ message: "Invalid rmk" });
                //     }
                    
                //     return true;
                //     }),

                //   amount: yup
                //     .number()
                //     .transform((value, originalValue) =>
                //       originalValue === "" ? null : value
                //     )
                //     .nullable()
                //     .typeError("Amount must be a number"),

                //     is_invalid_reason_code: yup.boolean(),

                //     is_invalid_rmk: yup.boolean()
                // })
                // )
                adjustments: yup.array().of(adjustmentSchema(3,jobData)),
            })
            ),
             claim_adjustments: yup.array().of(adjustmentSchema(2,jobData)), 
        })
        
      )
    })
  });

};
export default createValidationSchema;